/**
 * TanStack Query hooks for `igaming-gdpr-regional-data-residency-for-igaming-t`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingGdprRegionalDataResidencyForIgamingTQueryKeys,
	type CreateIgamingGdprRegionalDataResidencyForIgamingTBody,
	type ListIgamingGdprRegionalDataResidencyForIgamingTResponse,
	type IgamingGdprRegionalDataResidencyForIgamingTRow,
} from "./api";

export function useIgamingGdprRegionalDataResidencyForIgamingTList(): UseQueryResult<ListIgamingGdprRegionalDataResidencyForIgamingTResponse, Error> {
	return useQuery({
		queryKey: igamingGdprRegionalDataResidencyForIgamingTQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingGdprRegionalDataResidencyForIgamingTCreate(): UseMutationResult<IgamingGdprRegionalDataResidencyForIgamingTRow, Error, CreateIgamingGdprRegionalDataResidencyForIgamingTBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingGdprRegionalDataResidencyForIgamingTQueryKeys.all });
		},
	});
}

export function useIgamingGdprRegionalDataResidencyForIgamingTDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingGdprRegionalDataResidencyForIgamingTQueryKeys.all });
		},
	});
}
